"use strict";

import onInitModulesInScope from "../onInitModulesInScope";
import initModulesInScope from "@elements/init-modules-in-scope";
import {isValid} from "@elements/parsley-bootstrap-validation";

export function init() {
    onInitModulesInScope(function initInScope($scope) {
        $(".js-submit-form").each(function () {
            let $submitForm = $(this);
            let $submitButton = $submitForm.find(".js-submit-button");
            $submitButton.on("click", function (evt) {
                evt.preventDefault();
                evt.stopImmediatePropagation();
                let saveType = $(this).data("state-type");
                let checkModification = $(this).data("check-modification");
                $submitForm.data('save-type', saveType);
                $submitForm.data('check-modification', checkModification);
                $submitForm.trigger('submit');
            });

            $submitForm.on('submit', function (e) {
                if(!$submitForm.hasClass('js-parsley') || ($submitForm.hasClass('js-parsley') && isValid($submitForm))) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    let $formSuccess = $(".js-form-show-success");
                    let $formWarning = $(".js-form-show-warning");
                    let $formError = $(".js-form-show-error");
                    let $form = $(this);
                    let formAction = $form.attr('data-action') || $form.attr('action');
                    let saveType = $form.data('save-type');
                    let checkModification = $form.data('check-modification');

                    //reset of success and error message
                    $formSuccess.attr('hidden', true);
                    $formError.attr('hidden', true);
                    $formWarning.attr('hidden', true);

                    let formdata = new FormData(this);
                    formdata.append('save', 1);
                    formdata.append('saveType', saveType);
                    formdata.append('checkModification', checkModification);

                    $submitButton.prop('disabled', true);

                    $.ajax(formAction, {
                        method: 'POST',
                        data: formdata,
                        contentType: false,
                        processData:false,
                        enctype: 'multipart/form-data',
                    }).done(function (response) {
                        if (response.success && response.showModal) {

                            // it's not beautiful but it works for now
                            let reloadBtn = $('#overrideModal').find('.js-modal__reload');
                            let overrideBtn = $('#overrideModal').find('.js-modal__override');

                            $('#overrideModal').modal('show');
                            reloadBtn.click(function () {
                                location.reload();
                            });

                            overrideBtn.click(function (e) {
                                e.stopImmediatePropagation();
                                formdata.delete('checkModification');
                                formdata.append('checkModification', 'false');
                                $('#overrideModal').modal('hide');

                                $.ajax(formAction, {
                                    method: 'POST',
                                    data: formdata,
                                    contentType: false,
                                    processData:false,
                                    enctype: 'multipart/form-data',
                                }).done(function (response) {
                                    handleDbUpdateResponse(response, $form, $submitButton, saveType, $formWarning, $formSuccess, $formError);
                                }).fail(function () {
                                    $submitButton.prop('disabled', false);
                                    $formError.attr('hidden', false);
                                });
                            });

                        } else if (response.success) {
                            handleDbUpdateResponse(response, $form, $submitButton, saveType, $formWarning, $formSuccess, $formError);
                        } else {
                            $submitButton.prop('disabled', false);
                            $formError.attr('hidden', false);
                        }
                    }).fail(function () {
                        $submitButton.prop('disabled', false);
                        $formError.attr('hidden', false);
                    });
                }
            });
        })


        function readURL(input) {
            if (input.files && input.files[0]) {
                var reader = new FileReader();

                reader.onload = function(e) {
                    var id = $(input).data('id');
                    $('#' + id).attr('src', e.target.result).prop('hidden', false);
                };

                reader.readAsDataURL(input.files[0]);
            }
        }

        $(".js-imageupload").change(function() {
            readURL(this);
        });

        $('.js-imageupload-empty').on('click', function (e) {
            var id = $(this).data('id');
            $('.js-imageupload').val('');
            $('#' + id).attr('src', '').prop('hidden', true);
            $('#checkbox-deleteImage').prop('checked', true);
        })


    });

    function handleDbUpdateResponse(response, $form, $submitButton, saveType, $formError) {
        if (response.success) {
            if (response.html) {
                $form.empty().append(response.html);
                initModulesInScope($form);
            }

            if (saveType === "save") {
                $(".js-form-show-warning").attr('hidden', false);
            } else {
                $(".js-form-show-success").attr('hidden', false);
            }
        } else {
            $submitButton.prop('disabled', false);
            $formError.attr('hidden', false);
        }
    }
}